export const chatgptMandatoryOptions = [
    {
        key: "ChatGPTConversations",
        name: "ChatGPTConversations",
        title: "Chat History",
        description: "All the conversations you’ve had with ChatGPT.",
        optionPlatform: "chatgpt",
        essential: true,
        payment:"Mandatory",
        type: "standard",
        parent: null,
        use: null,
        warning: "This information may contain sensitive personal details that carry a risk of deanonymization. However, it will be stored on secure servers with strict access controls to protect your privacy."  
      },    

]; 


export const chatgptOptionalOptions = [
{
        key: "ChatGPTMessagefeedback",
        name: "ChatGPTMessagefeedback",
        title: "Message Feedbacks",
        description: "The feedback or ratings you’ve given on ChatGPT’s responses.",
        optionPlatform: "chatgpt",
        essential: false,
        payment:"Optional",
        type: "standard",
        parent: null,
        use: null,
        warning: null,
    },

    {
        key: "ChatGPTsharedConversations",
        name: "ChatGPTsharedConversations",
        title: "Shared Conversations",
        description: "The chats you’ve chosen to share with others.",
        optionPlatform: "chatgpt",
        essential: false,
        payment:"Optional",
        type: "standard",
        parent: null,
        use: null,
        warning: null,
    },

    {
        key: "ChatGPTUploadedImages",
        name: "ChatGPTUploadedImages",
        title: "Helper files",
        description: "Files you’ve uploaded (like PDFs or images) or ones generated by ChatGPT.",
        optionPlatform: "chatgpt",
        essential: false,
        payment:"Optional",
        type: "standard",
        parent: null,
        use: null,
        warning: "This information may contain sensitive personal details that carry a risk of deanonymization. However, it will be stored on secure servers with strict access controls to protect your privacy." 
    },

]; 



export const chatgptExcludedOptions = [

]; 